import type { ReactNode } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ArrowLeft, LogOut } from 'lucide-react';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';

export type AdminTab = 'leden' | 'evenementen' | 'siteinfo';

const PageWrapper = styled.div`
  padding: 8rem 0;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
  flex-wrap: wrap;
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;

const Tabs = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
`;

const TabButton = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  font-weight: bold;
  font-size: 1.1rem;
  color: ${({ $active, theme }) => ($active ? theme.colors.primary.royalBlue : '#888')};
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  background-color: ${({ $active }) => ($active ? '#f0f9ff' : 'transparent')};

  &:hover {
    color: ${({ theme }) => theme.colors.primary.royalBlue};
  }
`;

export const AdminShell = ({
  activeTab,
  onTabChange,
  onLogout,
  children,
}: {
  activeTab: AdminTab;
  onTabChange: (tab: AdminTab) => void;
  onLogout: () => void;
  children: ReactNode;
}) => (
  <PageWrapper>
    <Container maxWidth="2xl">
      <Header>
        <h1>Portaal Bestuur</h1>
        <HeaderActions>
          <Link to="/member">
            <Button variant="ghost">
              <ArrowLeft size={16} style={{ marginRight: '0.5rem' }} /> Terug naar Ledenportaal
            </Button>
          </Link>
          <Button variant="ghost" onClick={onLogout}>
            <LogOut size={16} style={{ marginRight: '0.5rem' }} /> Uitloggen
          </Button>
        </HeaderActions>
      </Header>

      <Tabs>
        <TabButton $active={activeTab === 'leden'} onClick={() => onTabChange('leden')}>Leden</TabButton>
        <TabButton $active={activeTab === 'evenementen'} onClick={() => onTabChange('evenementen')}>Kalender</TabButton>
        <TabButton $active={activeTab === 'siteinfo'} onClick={() => onTabChange('siteinfo')}>Siteinfo</TabButton>
      </Tabs>

      {children}
    </Container>
  </PageWrapper>
);
